<div class="dialog custom-form" [formGroup]="bankDetailsForm">
    <h6 class="semi-bold">Bank Account:</h6>
    <h6 class="mt-3 bold">You will Receive Payment in the below Bank Account</h6>
    <label for="">Account Name:</label>
    <input type="text" formControlName="account_name">
    <div class="row mb-2">
        <div class="col-md-6">
            <label class="mb-2 mt-3" for="">Account Type:</label>
            <span class="form-error-text" *ngIf="bankDetailsForm.get('account_type').touched && bankDetailsForm.get('account_type').invalid"> *Required</span>
            <input type="text" formControlName="account_type">
            <label class="mb-2 mt-3" for="">Bank Name:</label>
            <input type="text" formControlName="bank_name">
            <label class="mb-2 mt-3" for="">IFSC code:</label>
            <input type="text" formControlName="bank_ifsc">
        </div>
        <div class="col-md-6">
            <label class="mb-2 mt-3" for="">Account No:</label>
            <span class="form-error-text" *ngIf="bankDetailsForm.get('account_type').touched && bankDetailsForm.get('account_type').invalid"> *</span>
            <input type="text" formControlName="account_number">
            <label class="mb-2 mt-3" for="">Branch</label>
            <input type="text" formControlName="bank_branch">
            <label class="mb-2 mt-3" for="">Currency</label>
            <input type="text" formControlName="currency">
        </div>
    </div>
    <div class="button mt-4 row">
        <button class="mr-2 white" (click)="close()">Cancel</button>
        <button class="ml-2 orange" (click)="submitDetails()">Confirm</button>
    </div>
</div>